module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"emptyBasket":"Ihr Warenkorb ist leer","goToOffer":"Zum Angebot!"},"en":{"emptyBasket":"Your cart is empty","goToOffer":"Go to the offer!"}}')
  delete Component.options._Ctor
}
